module.exports = __webpack_public_path__ + "static/media/Kimmy Design - CatalinaClementeBold-Italic.6f3aae9b.otf";